import { Injectable, signal, computed } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavigationItem } from './navigation.model';
import { defaultNavigation } from './navigation';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  /**
   * BehaviorSubject seeded with defaultNavigation (legacy — kept for existing subscribers).
   * New code should prefer the `navigation` signal.
   */
  private _navigation = new BehaviorSubject<NavigationItem[]>(defaultNavigation);

  /** Angular Signal — reactive, no subscription needed. Use in templates with `()`. */
  readonly navigationSignal = signal<NavigationItem[]>(defaultNavigation);

  /** Computed: count of top-level navigable modules (for badges, etc.) */
  readonly moduleCount = computed(() =>
    this.navigationSignal().reduce((count, group) => count + (group.children?.length ?? 0), 0),
  );

  /** @deprecated Use `navigationSignal()` in new code */
  get navigation$(): Observable<NavigationItem[]> {
    return this._navigation.asObservable();
  }

  set navigation(value: NavigationItem[]) {
    this._navigation.next(value);
    this.navigationSignal.set(value);
  }

  get navigationValue(): NavigationItem[] {
    return this._navigation.getValue();
  }
}
